'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _immutable = require('immutable');

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FeisFinalizeController = function FeisFinalizeController($mdDialog, feis, fFeisService) {
  var _this = this;

  _classCallCheck(this, FeisFinalizeController);

  this._ = {
    $mdDialog: $mdDialog,
    fFeisService: fFeisService
  };
  this.feis = feis;

  this.finalize = function () {
    var dialog = _this._.$mdDialog.confirm().title('Are you sure?').htmlContent('<p>After the Feis is Closed, you will no longer be able to make edits or changes.</p>' + '<p>Please contact iFeis if you need to make changes after the Feis is closed.</p>').ok('Close').cancel('Cancel');

    _this._.$mdDialog.show(dialog).then(function () {
      _this._.fFeisService.finalize(_this.feis.id);
      _this.feis.is_finalized = 1;
    });
  };
};

exports.default = _angular2.default.module('ifeis.routes.feiseanna.one.admin.finalize', ['ngMaterial', 'ngSanitize', 'ui.router', 'ifeis.router-history']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.finalize', {
    url: '/finalize',
    template: require('./tpl.html'),
    controller: FeisFinalizeController,
    controllerAs: 'finalize',
    ncyBreadcrumb: {
      label: 'Close Feis',
      parent: 'feiseanna.one.admin.manager'
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/finalize/index.js
// module id = 544
// module chunks = 0